import React from 'react';
import NewPass from '../../components/authbox/newPass.jsx';
import './newPass.css';

const NewPassword = () => {
    return (
        <div className="pass_body">
            <NewPass />
        </div>
    )
}

export default NewPassword;